import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../index";
import { OrdersAPI } from "../../services/orders/orders.service";
import { Order } from "../../services/orders/dto/orders.dto";
interface ordersState {
	loadingOrders: boolean;
	orders: Order[];
	adminOrders: Order[];
	totalItems: number;
}

const initialState: ordersState = {
	loadingOrders: false,
	orders: [],
	adminOrders: [],
	totalItems: 0
};

const ordersSlice = createSlice({
	name: "orders",
	initialState,
	reducers: {},
	extraReducers: builder =>
		builder
			.addMatcher(OrdersAPI.endpoints.getOrders.matchPending, state => {
				state.loadingOrders = true;
			})
			.addMatcher(OrdersAPI.endpoints.getOrders.matchFulfilled, (state, action) => {
				state.loadingOrders = false;
				state.orders = action.payload.items;
				state.totalItems = action.payload.totalItems || 0;
			})
			.addMatcher(OrdersAPI.endpoints.getOrders.matchRejected, state => {
				state.loadingOrders = false;
			})
			.addMatcher(OrdersAPI.endpoints.getAdminOrders.matchPending, state => {
				state.loadingOrders = true;
			})
			.addMatcher(OrdersAPI.endpoints.getAdminOrders.matchFulfilled, (state, action) => {
				state.loadingOrders = false;
				state.adminOrders = action.payload.items;
				state.totalItems = action.payload.totalItems || 0;
			})
			.addMatcher(OrdersAPI.endpoints.getAdminOrders.matchRejected, state => {
				state.loadingOrders = false;
			})
});

// export const {} = ordersSlice.actions;
export const getFullOrdersState = (state: RootState): ordersState => state.orders;
export default ordersSlice.reducer;
